import { useState } from 'react'
import { Popover, theme } from 'antd'
import { SmileOutlined } from '@ant-design/icons'
import { REACTION_EMOJIS } from '../../Helpers/emojis'

interface ReactionPickerProps {
  onSelect: (emoji: string) => void
  activeEmojis?: string[]
  children?: React.ReactNode
}

const ReactionPicker = ({ onSelect, activeEmojis = [], children }: ReactionPickerProps) => {
  const { token } = theme.useToken()
  const [open, setOpen] = useState(false)
  const [hoveredEmoji, setHoveredEmoji] = useState<string | null>(null)

  const handleSelect = (emoji: string) => {
    onSelect(emoji)
    setOpen(false)
  }

  const getBackground = (emoji: string) => {
    const isActive = activeEmojis.includes(emoji)
    if (isActive) return token.colorPrimaryBg
    if (hoveredEmoji === emoji) return token.colorFillTertiary
    return 'transparent'
  }

  const content = (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(10, 1fr)',
        gap: 2,
        padding: 4,
      }}
    >
      {REACTION_EMOJIS.map((emoji) => {
        const isActive = activeEmojis.includes(emoji)
        return (
          <div
            key={emoji}
            onClick={() => handleSelect(emoji)}
            onMouseEnter={() => setHoveredEmoji(emoji)}
            onMouseLeave={() => setHoveredEmoji(null)}
            style={{
              fontSize: 20,
              textAlign: 'center',
              padding: '4px 2px',
              cursor: 'pointer',
              borderRadius: 6,
              transition: 'background 0.15s, border-color 0.15s',
              background: getBackground(emoji),
              border: isActive ? `1px solid ${token.colorPrimaryBorder}` : '1px solid transparent',
            }}
          >
            {emoji}
          </div>
        )
      })}
    </div>
  )

  return (
    <Popover
      content={content}
      trigger="click"
      placement="top"
      open={open}
      onOpenChange={setOpen}
    >
      {children || (
        <SmileOutlined
          style={{
            fontSize: 14,
            cursor: 'pointer',
            color: token.colorTextQuaternary,
            transition: 'color 0.15s',
          }}
        />
      )}
    </Popover>
  )
}

export default ReactionPicker
